import {
  inject,
  Injectable,
} from '@angular/core';
import {
  RouterStateSnapshot,
  TitleStrategy,
} from '@angular/router';
import {TitleService} from './shared/services/infrastructure/page/chrome/title/title.service';

@Injectable({providedIn: 'root'})
export class AppTitleStrategy extends TitleStrategy {

  private titleService: TitleService = inject(TitleService);

  /**
   * Method: Update title for Tab in browser
   * @param snapshot
   */
  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title: string = this.buildTitle(snapshot);
    this.titleService.setTitle(title);
  }

}
